import { useLocation } from "react-router-dom";
import Header from "../../components/header/Header";
import Posts from "../../components/posts/Posts";
import Sidebar from "../../components/sidebar/Sidebar";
import "./home.css";
import axios from "axios";
import { useEffect, useState } from "react";
import Spinner from "../../components/spinner/Spinner"; // Assuming you have a spinner component

export default function Home() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state
  const { search } = useLocation();

  useEffect(() => {
    const fetchPosts = async () => {
      setLoading(true); // Start loader
      try {
        const res = await axios.get("https://amanapi.onrender.com/api/posts/" + search);
        setPosts(res.data);
      } catch (error) {
        console.error("Error fetching posts:", error);
      } finally {
        setLoading(false); // Stop loader when data is fetched
      }
    };
    fetchPosts();
  }, [search]);

  return (
    <>
      <Header />
      <div className="home">
        {loading ? ( // Conditionally render the spinner or posts
          <Spinner /> // Spinner component that you need to create
        ) : (
          <Posts posts={posts} />
        )}
        <Sidebar />
      </div>
    </>
  );
}
